import { Button } from 'reactstrap';
import { UnitPcvForm } from '../models/unitPcv';
import FormModal from '../../../components/modals/FormModal';
import useModalState from '../../../hooks/useModalState';
import ManageUnitPcvForm from './ManageUnitPcvForm';
import { useCallback } from 'react';
import useCallApiAndLoad from '../../../hooks/useCallApiAndLoad';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../../hooks/useAuth';
import { createPcvEndpoint } from '../services/unitPcvService';
import { fetchResponseAdapter } from '../../../adapters/fetchAdapter';

interface Props {
  projectId: string;
}

const UnitPcvCreateModal = ({ projectId }: Props) => {
  const [isOpenModal, toggleModal] = useModalState();

  const { callEndpoint } = useCallApiAndLoad();
  const navigate = useNavigate();
  const { getAuthToken } = useAuth();
  const token = getAuthToken();

  const handleForm = useCallback(
    async (form: UnitPcvForm, errorRepository: Function) => {
      const { status, data } = await callEndpoint(
        createPcvEndpoint(projectId, form, token),
      );
      const response = fetchResponseAdapter(data);
      if (status === 201) navigate(0);
      else errorRepository(response.message);
    },
    [],
  );

  const createForm = <ManageUnitPcvForm handleForm={handleForm} />;

  return (
    <>
      <Button color="success" size="sm" onClick={() => toggleModal()}>
        <i className={'ni ni-fat-add'} /> Crear nueva PCV
      </Button>
      <FormModal
        headerText="Crear nueva PCV"
        children={createForm}
        isOpen={isOpenModal}
        onConfirmation={() => {}}
        onReset={() => {}}
        onToggle={toggleModal}
        size="lg"
        withFooterActions={false}
      />
    </>
  );
};

export default UnitPcvCreateModal;
